module.exports = __webpack_public_path__ + "static/media/Anagha_Mahure.b3a8e7ff.jpg";